import React, { useState, useEffect } from 'react';
import { Button, Spinner, Alert, Form } from "@themesberg/react-bootstrap";
import { Row } from "@themesberg/react-bootstrap";
import axios from 'axios';
import { BASE_URL } from '../constants';
import { Col } from 'react-bootstrap';

const ShelterSettings = ({ shelterId }) => {
  // States for Absent Days
  const [dayThreshold, setDayThreshold] = useState('');
  const [loadingAbsentDays, setLoadingAbsentDays] = useState(false);
  const [successAbsentDays, setSuccessAbsentDays] = useState(false);
  const [errorAbsentDays, setErrorAbsentDays] = useState(null);

  // States for Auto Checkout Hours
  const [autoCheckoutHours, setAutoCheckoutHours] = useState('');
  const [loadingAutoCheckout, setLoadingAutoCheckout] = useState(false);
  const [successAutoCheckout, setSuccessAutoCheckout] = useState(false);
  const [errorAutoCheckout, setErrorAutoCheckout] = useState(null);

  // Fetch Absent Days
  useEffect(() => {
    if (!shelterId) return;
    const fetchAbsentDays = async () => {
      setLoadingAbsentDays(true);
      try {
        const res = await axios.get(`${BASE_URL}/shelters/${shelterId}/absent-days`);
        if (res.data && typeof res.data.absentDays === 'number') {
          setDayThreshold(res.data.absentDays);
        } else {
          setErrorAbsentDays('Invalid response for absent days.');
        }
      } catch (err) {
        console.error(err);
        setErrorAbsentDays('Failed to fetch absent days.');
      } finally {
        setLoadingAbsentDays(false);
      }
    };
    fetchAbsentDays();
  }, [shelterId]);

useEffect(() => {
  if (!shelterId) return;

  const fetchAutoCheckout = async () => {
    setLoadingAutoCheckout(true);
    try {
      const res = await axios.get(`${BASE_URL}/shelters/${shelterId}/auto-checkout-hours`);
   

      if (res.data && typeof res.data.autoCheckoutHours === 'number') {
        setAutoCheckoutHours(res.data.autoCheckoutHours);
      } else {
        setErrorAutoCheckout('Invalid response for auto-checkout hours.');
      }
    } catch (err) {
      console.error("Axios error:", err);
      setErrorAutoCheckout('Failed to fetch auto-checkout hours.');
    } finally {
      setLoadingAutoCheckout(false);
    }
  };

  fetchAutoCheckout();
}, [shelterId]);


  // Save Absent Days
  const handleSaveAbsentDays = async () => {
    setLoadingAbsentDays(true);
    setSuccessAbsentDays(false);
    setErrorAbsentDays(null);
    try {
      await axios.put(`${BASE_URL}/shelters/${shelterId}/absent-days`, { absentDays: Number(dayThreshold) });
      setSuccessAbsentDays(true);
      setTimeout(() => setSuccessAbsentDays(false), 3000);
    } catch (err) {
      console.error(err);
      setErrorAbsentDays('Failed to save absent days.');
    } finally {
      setLoadingAbsentDays(false);
    }
  };

  // Save Auto-Checkout Hours
  const handleSaveAutoCheckout = async () => {
    setLoadingAutoCheckout(true);
    setSuccessAutoCheckout(false);
    setErrorAutoCheckout(null);
    try {
      await axios.put(`${BASE_URL}/shelters/${shelterId}/auto-checkout-hours`, { autoCheckoutHours: Number(autoCheckoutHours) });
      setSuccessAutoCheckout(true);
      setTimeout(() => setSuccessAutoCheckout(false), 3000);
    } catch (err) {
      console.error(err);
      setErrorAutoCheckout('Failed to save auto-checkout hours.');
    } finally {
      setLoadingAutoCheckout(false);
    }
  };

return (
<Row>
    {/* Absent Days */}
    <Col md={6}>
    <div className="d-flex align-items-center gap-2 mb-4">
      <Form.Label className="mb-0"><strong>Absent Days:</strong></Form.Label>
      <Form.Control
        type="number"
        min="1"
        value={dayThreshold}
        onChange={(e) => setDayThreshold(e.target.value)}
        disabled={loadingAbsentDays}
        style={{ width: 100 }}
      />
      <Button
        onClick={handleSaveAbsentDays}
        disabled={loadingAbsentDays || dayThreshold === ""}
      >
        {loadingAbsentDays ? <Spinner animation="border" size="sm" /> : "Save"}
      </Button>
    </div>
    {successAbsentDays && <Alert variant="success">Absent days updated!</Alert>}
    {errorAbsentDays && <Alert variant="danger">{errorAbsentDays}</Alert>}
</Col>
    {/* Auto Checkout Hours */}
     <Col md={6}>
    <div className="d-flex align-items-center gap-2 mb-4">
      <Form.Label className="mb-0"><strong>Auto Checkout Hours:</strong></Form.Label>
      <Form.Control
        type="number"
        min="1"
        value={autoCheckoutHours}
        onChange={(e) => setAutoCheckoutHours(e.target.value)}
        disabled={loadingAutoCheckout}
        style={{ width: 100 }}
      />
      <Button
        onClick={handleSaveAutoCheckout}
        disabled={loadingAutoCheckout || autoCheckoutHours === ""}
      >
        {loadingAutoCheckout ? <Spinner animation="border" size="sm" /> : "Save"}
      </Button>
    </div>
    {successAutoCheckout && <Alert variant="success">Auto-checkout hours updated!</Alert>}
    {errorAutoCheckout && <Alert variant="danger">{errorAutoCheckout}</Alert>}
    </Col>
</Row>
);
};

export default ShelterSettings;
